import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_8dsucv84: FaireBrandEntity = {
  token: "b_8dsucv84",
  type: "brand",
  name: "MOD REF",
  avatarUrl:
    "https://cdn.faire.com/fastly/8f42c462ef0896b58bdd8d2df3d446a51e8862645437bcce9c1397d3cf7d31ad.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/473fa65ec67f05a7cdcaf97b1669b32b6f87041ea05167f61609af928e323f14.png",
  logoUrl:
    "https://cdn.faire.com/fastly/8f42c462ef0896b58bdd8d2df3d446a51e8862645437bcce9c1397d3cf7d31ad.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/473fa65ec67f05a7cdcaf97b1669b32b6f87041ea05167f61609af928e323f14.png",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 0,
  rating: 4.7,
  reviewCount: 171,
  isInsider: true,
  description:
    "MOD REF is a lifestyle brand for women who want classic, minimal, and enduring design with a focus on garments that can provide a sense of confidence and poise.\n\nWe create classic and staple pieces that are essential for your wardrobe and fit to wear season after season, long after fashion trends have tapered off.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T06:21:42.752Z",
    importedBy: "entity-db-cli",
  },
};
